import config from "../config";
import getAccessToken from "./auth";

export const fetchSmartFormTemplates = async () => {
  const accessToken = await getAccessToken();
  const apiBaseUrl = config.apiEndpoint;

  const response = await fetch(`${apiBaseUrl}/api/smartformtemplates`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      "x-functions-key": config.functionKey
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch smart form templates: ${response.statusText}`);
  }

  return response.json();
};
